import { useEffect, useRef } from 'react';

export const useKeyboardFocus = () => {
  const wasKeyboard = useRef<boolean>(false);
  const timeoutRef = useRef<NodeJS.Timeout | undefined>(undefined);

  useEffect(() => {
    const handleKeyDown = () => {
      wasKeyboard.current = true;
    };

    const handleMouseDown = () => {
      clearTimeout(timeoutRef.current);
      wasKeyboard.current = false;
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("mousedown", handleMouseDown);
    
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("mousedown", handleMouseDown);
      clearTimeout(timeoutRef.current);
    };
  }, []);

  return {
    wasKeyboard,
    onFocus: (callback?: () => void) => {
      if (wasKeyboard.current && callback) {
        callback();
      }
      
      // Reset keyboard state after 100ms
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        wasKeyboard.current = false;
      }, 100);
    },
    onBlur: (callback?: () => void) => {
      if (callback) {
        callback();
      }
    }
  };
}; 